import React from 'react';
import { Form, Select, Segment, Table, Header, Button } from 'semantic-ui-react';

export default class FacultyChanges extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            faculty: ''

        };
        this.onAddNewFacultyChange = this.onAddNewFacultyChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    onAddNewFacultyChange() {
        const faculty = this.props.faculties.find(el => el.id === this.state.faculty);
        if (faculty) this.props.onAddNewFacultyChange(this.state.faculty);
        this.setState({ faculty: '' });
    }
    handleInputChange(event, { name, value }) {
        this.setState({ [name]: value });
    }
    render() {
        const { facultyChanges } = this.props;
        return (
            <div>
                {!!facultyChanges.length &&
                <div className={!this.props.noSegment && 'ui clearing segment'}>
                    <Table>
                        <Table.Body>
                            {this.props.facultyChanges.map(el => (
                                <Table.Row>
                                    <Table.Cell verticalAlign="middle">{el.name ? el.name : this.props.faculties.find(e => e.id === el.id).name}</Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Button
                                            basic="true"
                                            color="red"
                                            onClick={() => this.props.onDeleteFacultyChange(el.id)}
                                            floated="right"
                                        >Obriši</Button>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
                }

                {this.props.noSegment && <br />}

                <div className={!this.props.noSegment && 'ui clearing segment'}>
                    <Form>
                        <Form.Field
                            control={Select}
                            clearable
                            options={this.props.faculties.map(el => ({ key: el.id, value: el.id, text: el.name }))}
                            value={this.state.faculty}
                            onChange={this.handleInputChange}
                            label="Fakultet"
                            name="faculty"
                            selection
                            search
                        />
                        <Button primary floated="right" onClick={this.onAddNewFacultyChange}>Dodaj</Button>
                    </Form>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/FacultyChanges.js